exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-full[data-v-3689e715]{width:100%}\n", ""]);

// exports
